import { atom, useAtomValue, useSetAtom } from 'jotai';

const systemModalActiveKeyState = atom<string | undefined>(undefined);

const systemModalActiveFeatureState = atom<string | undefined>(undefined);

export const useSystemModalActiveKey = () => useAtomValue(systemModalActiveKeyState);
export const useSetSystemModalActiveKey = () => useSetAtom(systemModalActiveKeyState);
export const useSystemModalActiveFeature = () => useAtomValue(systemModalActiveFeatureState);
export const useSetSystemModalActiveFeature = () => useSetAtom(systemModalActiveFeatureState);
